import React from 'react';
import { Upload, Plus } from 'lucide-react';

export default function AddEventActions({ onScreenshot, onManual, className = 'mt-6' }) {
  return (
    <div className={`flex justify-center gap-4 ${className}`}>
      <button
        onClick={onScreenshot}
        className="p-3 bg-blue-50 hover:bg-blue-100 rounded-full transition-colors"
        title="Add from Screenshot"
      >
        <Upload size={20} className="text-blue-600" />
      </button>
      <button
        onClick={onManual}
        className="p-3 bg-gray-50 hover:bg-gray-100 rounded-full transition-colors"
        title="Add Manually"
      >
        <Plus size={20} className="text-gray-600" />
      </button>
    </div>
  );
}
